import DIApi from './_diApi';

class BudgetGroupItemAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetGroupItems';
}

export default new BudgetGroupItemAPI();
